<div class="bg-cover bg-center h-screen w-screen" style="background-image: url('assets/img/01-BG_AC_Force_N.png')">
  <div class="h-full w-full flex items-center justify-center bg-black bg-opacity-50">
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex">
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <div
              class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
              <svg aria-hidden="true" class="w-8 h-8 text-green-500 dark:text-green-400" fill="currentColor"
                viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"></path>
              </svg>
              <span class="sr-only">Success</span>
            </div>
            <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Votre candidature a bien été prise en compte. Vous recevrez une
              notification par e-mail pour valider votre
              candidature. En savoir plus sur le programme

              <a style="color: blue" href="https://force-n.sn/">https://force-n.sn/</a>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>